import { __assign } from 'tslib';
import * as React from 'react';
import JsxParser from 'react-jsx-parser';
import { AtomSectionContext } from './AtomSectionContext.esm.js';

var JSX = function (_a) {
    var html = _a.html;
    var mapping = React.useContext(AtomSectionContext);
    return React.createElement(JsxParser, { components: __assign({}, mapping), jsx: html });
};
var JSX$1 = React.memo(JSX, function (prevProps, newProps) { return prevProps.html === newProps.html; });

export { JSX$1 as default };
//# sourceMappingURL=JSX.esm.js.map
